
    angular.module('GorillaBoy.services')
    .factory('BaseService', 
        ['$http', 
        '$q', 
        '$log', 
        '$timeout',
        'EndpointService', 
        'AppConstants', 

       function($http, $q, $log, $timeout, EndpointService, AppConstants) {

            var baseService = {};

            // service call config is an object that contains the config for the service call.    
            // reducerFunction is a function that takes the service call results list and concatenates it.
            baseService.getAllPages = function(serviceCallConfig, reducerFunction){

                $log.info("entered baseService.getAllPages with config : " + 
                    JSON.stringify(serviceCallConfig) );

                var newDeferred = $q.defer();
                var results = [];
                var initialMarker ;

                return baseService.loopServiceCalls(serviceCallConfig, initialMarker, results, newDeferred, reducerFunction);

            };

            baseService.loopServiceCalls = function(config, marker, results, deferred, reduceFunction){
             
                function errorCallBack(response){
                    $log.error("Error making full page call for config : "+
                        JSON.stringify(config) + ", Error : " + JSON.stringify(response));
                 
                    deferred.reject(response);
                }

                function successCallBack(response){
                    results.push(response.data);
                        $log.info("Got marker : " + response.data.Marker);
               
                        if( response.data.Marker &&
                            (response.data.Marker !== null) && 
                            (response.data.Marker != "null")){

                            $log.debug("Looping for next page for call with config : "+ JSON.stringify(config));
                            baseService.loopServiceCalls(config, response.data.Marker, results, deferred, reduceFunction);
                        }else{

                           $log.debug("Reducing pages for call with config : " + JSON.stringify(config));
                           deferred.resolve(reduceFunction(results));
                        }
                    }

                function callInvoker(){
                    return baseService.callOnce(config, marker); 
                }  

                baseService.callWithLinearRetries(callInvoker, $q.defer())
                .then(successCallBack, errorCallBack);

                return deferred.promise;
            };


            baseService.isRetryableErrorCode = function(statusCode){
               
                return (statusCode > 500 && statusCode < 600);
            };


           baseService.callWithLinearRetries = function(callInvoker, deferred, retryCount){
       
                if(!retryCount){
                     retryCount = 0;
                }

                $log.debug("Entered callWithLinearRetries. RetryCount = " + retryCount);

                function successCallBack(response){
                    deferred.resolve(response);
                }

                function errorCallBack(response){
                    if(!baseService.isRetryableErrorCode(response.status)){
                        $log.error("Non-Retriable error for Service Call; Error Status : " +
                            response.status + "; Error : " +  
                            JSON.stringify(response.data));
                        deferred.reject(response);
                        return;
                    }
                       
                    if(retryCount < AppConstants.HTTP_THROTTLE_MAX_RETRY_COUNT){

                        retryCount++;
                        $log.info("Retry Number : "+retryCount+" for Service Call; Error Status : " +
                                response.status + "; Error : " +  
                                JSON.stringify(response.data));

                        $timeout(function() {
                            return baseService.callWithLinearRetries(callInvoker, deferred, retryCount);
                        }, AppConstants.HTTP_THROTTLE_RETRY_DELAY_IN_MILLISEC);

                    }else{
                        $log.error("Exhausted Linear Retry Attempts; Error : " +
                            JSON.stringify(response.data));
                        deferred.reject(response);
                    }
                }

                callInvoker().then(successCallBack, errorCallBack);

                return deferred.promise;
            };


            baseService.callOnce = function(config, marker){
                if(marker){
                    config.params.marker = marker;
                }
                $log.info("Making Service Call with config : " + JSON.stringify(config));
                return $http(EndpointService.tokenize(config));
            };
           

            return baseService;

        } // function within factory ends
    ]);  // factory ends

